import { IHallBooking } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
	update: {
		startDate?: number
		endDate?: number
		locationId?: string
		contactId?: string
		reason?: string
		deposit?: number
		paymentRemarks?: string
	}
}

export async function hallBookingUpdateApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/hall/booking/update/v1"
	const requester = new ApiRequester<RequestDataShape, IHallBooking>(endpoint)
	return await requester.sendRequest(payload, token)
}
